import React from 'react';

import CommonModal from '../../components/common-modal/CommonModal.component';

import './TermsAgreementModal.component.scss';

/**
 * Full terms body + explicit "I agree" (checks parent form T&C when used with setValue).
 */
function TermsAgreementModal({ isOpen, onClose, onAgree }) {
    const onAgreeClick = () => {
        onAgree?.();
        onClose?.();
    };

    return (
        <CommonModal
            title='Terms and conditions'
            modalClassName='terms-agreement-modal'
            contentClassName='terms-agreement-content'
            isOpen={isOpen}
            onClose={onClose}
        >
            <div className='terms-agreement-scroll'>
                <div className="terms-body">
                    <h3>#Merky FC Cup 2026 – 3v3 Tournament Terms & Conditions</h3>
                    <p>By submitting an application to enter the #Merky FC Cup 2026 3v3 Tournament (“Tournament”), all players and team representatives agree to the following Terms & Conditions.</p>
                    <hr />

                    <h4>1. Organiser</h4>
                    <p>1.1 The Tournament is operated and organised by #Merky FC in partnership with Adidas (“Organiser”).</p>
                    <p>1.2 The Tournament will take place on Sunday 31 May 2026 at #Merky FC HQ, London (“Venue”).</p>
                    <p>1.3 The Organiser reserves the right to amend, postpone, suspend or cancel the Tournament or any element of it at any time without prior notice where reasonably necessary due to operational, legal, safety or circumstances outside of their control.</p>
                    <hr />

                    <h4>2. Eligibility</h4>
                    <p>2.1 Entry is open only to individuals aged between 18 and 25 years old on the date of the Tournament.</p>
                    <p>2.2 All players must be legal residents of the United Kingdom or have the eligibility through a visa or permit.</p>
                    <p>2.3 All players must hold:</p>
                    <ul>
                        <li>a valid UK passport; or</li>
                        <li>a valid passport and visa/immigration status permitting travel to and entry into the United States of America.</li>
                    </ul>
                    <p>2.4 Each player must:</p>
                    <ul>
                        <li>be available to travel between 22 June 2026 and 28 June 2026;</li>
                        <li>be legally permitted to enter and remain in the USA;</li>
                        <li>not have any criminal convictions, immigration restrictions or legal circumstances that may prevent travel to or entry into the USA.</li>
                    </ul>
                    <p>2.5 Each team must consist of exactly three (3) players. No substitutes will be permitted unless expressly approved in writing by the Organiser.</p>
                    <p>2.6 A player may only register and compete for one team. Any player found to have entered multiple teams may result in the disqualification of all associated teams.</p>
                    <p>2.7 Employees, contractors or representatives of the Organiser, affiliated sponsors, production partners or any immediate family members may be excluded from participation at the Organiser’s discretion.</p>
                    <hr />

                    <h4>3. Registration & Verification</h4>
                    <p>3.1 All information submitted during registration must be accurate, truthful and complete.</p>
                    <p>3.2 The Organiser reserves the right to request proof of:</p>
                    <ul>
                        <li>identity;</li>
                        <li>age;</li>
                        <li>nationality;</li>
                        <li>residency;</li>
                        <li>passport validity;</li>
                        <li>travel eligibility; and/or</li>
                        <li>any other relevant information required for Tournament participation.</li>
                    </ul>
                    <p>3.3 Identification checks will take place before the Tournament and/or on the event day.</p>
                    <p>3.4 Any false, misleading or incomplete information may result in immediate disqualification of the entire team without notice.</p>
                    <p>3.5 Teams must complete registration by the stated closing date. Late, incomplete or invalid entries may not be accepted.</p>
                    <hr />

                    <h4>4. Tournament Format</h4>
                    <p>4.1 The Tournament format, fixtures, timings and rules are determined solely by the Organiser.</p>
                    <p>4.2 The Organiser reserves the right to amend the format, schedule, rules or structure of the Tournament at any time.</p>
                    <p>4.3 Match officials and event staff decisions are final. No correspondence or disputes will be entered into regarding decisions made during gameplay.</p>
                    <p>4.4 Unsportsmanlike conduct, violence, discrimination, abuse, intimidation, dangerous play or misconduct towards players, staff, officials or attendees may result in:</p>
                    <ul>
                        <li>removal from the Tournament;</li>
                        <li>removal from the Venue; and/or</li>
                        <li>permanent exclusion from future #Merky FC events.</li>
                    </ul>
                    <hr />

                    <h4>5. Behaviour & Conduct</h4>
                    <p>5.1 All participants must behave respectfully and professionally throughout the Tournament and while attending the Venue.</p>
                    <p>5.2 Any participant deemed by the Organiser to:</p>
                    <ul>
                        <li>bring the Tournament, #Merky FC, adidas or associated partners into disrepute;</li>
                        <li>damage property;</li>
                        <li>act aggressively or unlawfully; or</li>
                        <li>behave in a manner considered unsafe or inappropriate, may be removed immediately and disqualified.</li>
                    </ul>
                    <p>5.3 Discrimination, hate speech, harassment, threatening behaviour or offensive conduct of any kind will not be tolerated.</p>
                    <p>5.4 The Organiser reserves the right to conduct security checks and refuse entry to any person at their discretion.</p>
                    <hr />

                    <h4>6. Prize</h4>
                    <p>6.1 Subject to compliance with these Terms & Conditions, the winning team will receive:</p>
                    <ul>
                        <li>a trip to New Jersey, USA;</li>
                        <li>tickets to attend the FIFA World Cup 2026 England v Panama fixture; and</li>
                        <li>associated travel arrangements determined by the Organiser.</li>
                    </ul>
                    <p>6.2 The prize is non-transferable, non-refundable and cannot be exchanged for cash or alternative prizes.</p>
                    <p>6.3 The Organiser reserves the right to substitute the prize or elements of the prize with alternatives of equal or greater value where reasonably necessary.</p>
                    <p>6.4 Winners are solely responsible for:</p>
                    <ul>
                        <li>ensuring passport validity;</li>
                        <li>obtaining any required visas or travel authorisations;</li>
                        <li>complying with immigration requirements;</li>
                        <li>arranging personal spending money;</li>
                        <li>obtaining suitable travel insurance unless otherwise stated.</li>
                    </ul>
                    <p>6.5 If any player is unable to travel for any reason including:</p>
                    <ul>
                        <li>passport issues;</li>
                        <li>visa refusal;</li>
                        <li>criminal convictions;</li>
                        <li>medical restrictions;</li>
                        <li>failure to meet immigration requirements; or</li>
                        <li>personal unavailability, the Organiser shall have no liability and may withdraw the prize from that individual and/or the team.</li>
                    </ul>
                    <p>6.6 The Organiser reserves the right to select an alternative winner or amend the prize structure where a winning team or player cannot fulfil travel requirements.</p>
                    <hr />

                    <h4>7. Media, Photography & Content</h4>
                    <p>7.1 By attending and participating in the Tournament, participants grant the Organiser and affiliated partners the unrestricted right to:</p>
                    <ul>
                        <li>film;</li>
                        <li>photograph;</li>
                        <li>livestream;</li>
                        <li>record audio; and</li>
                        <li>capture content featuring participants.</li>
                    </ul>
                    <p>7.2 Participants grant the Organiser a perpetual, worldwide, royalty-free licence to use their name, image, likeness, voice and content captured during the Tournament for:</p>
                    <ul>
                        <li>marketing;</li>
                        <li>advertising;</li>
                        <li>promotional;</li>
                        <li>editorial;</li>
                        <li>commercial; and</li>
                        <li>social media purposes, in any media format now known or later developed.</li>
                    </ul>
                    <p>7.3 Participants waive any right to review or approve final content or claim compensation relating to the use of such materials.</p>
                    <hr />

                    <h4>8. Health & Safety</h4>
                    <p>8.1 Participants acknowledge that football and related physical activities involve inherent risks of injury.</p>
                    <p>8.2 Participants compete entirely at their own risk.</p>
                    <p>8.3 Players confirm they are medically fit and physically capable of participating.</p>
                    <p>8.4 The Organiser accepts no responsibility for:</p>
                    <ul>
                        <li>injury;</li>
                        <li>illness;</li>
                        <li>loss;</li>
                        <li>theft;</li>
                        <li>damage to belongings; or</li>
                        <li>any other harm suffered during or in connection with the Tournament, except where caused by negligence that cannot legally be excluded.</li>
                    </ul>
                    <p>8.5 Participants must follow all instructions issued by event staff, security personnel and medical teams.</p>
                    <hr />

                    <h4>9. Liability</h4>
                    <p>9.1 To the fullest extent permitted by law, the Organiser shall not be liable for:</p>
                    <ul>
                        <li>cancellations;</li>
                        <li>delays;</li>
                        <li>transport disruption;</li>
                        <li>visa refusal;</li>
                        <li>lost entries;</li>
                        <li>technical failures;</li>
                        <li>personal losses; or</li>
                        <li>circumstances outside of their reasonable control.</li>
                    </ul>
                    <p>9.2 Nothing in these Terms & Conditions excludes liability for death or personal injury caused by negligence or any liability that cannot legally be excluded under English law.</p>
                    <hr />

                    <h4>10. Data Protection</h4>
                    <p>10.1 Personal data submitted in connection with the Tournament will be processed by the Organiser for:</p>
                    <ul>
                        <li>administration of the Tournament;</li>
                        <li>participant verification;</li>
                        <li>event operations;</li>
                        <li>travel arrangements;</li>
                        <li>marketing communications where consent is provided; and</li>
                        <li>related promotional activities.</li>
                    </ul>
                    <p>10.2 Personal data may be shared with trusted third parties involved in delivering the Tournament and prize fulfilment.</p>
                    <p>10.3 Participants confirm that all information submitted belongs to them and is provided with appropriate consent.</p>
                    <hr />

                    <h4>11. Disqualification</h4>
                    <p>11.1 The Organiser reserves the right to disqualify any individual or team where they reasonably believe there has been:</p>
                    <ul>
                        <li>breach of these Terms & Conditions;</li>
                        <li>cheating or manipulation;</li>
                        <li>abusive behaviour;</li>
                        <li>false information submitted;</li>
                        <li>rule violations; or</li>
                        <li>conduct damaging to the Tournament or associated brands.</li>
                    </ul>
                    <p>11.2 Disqualification decisions are final.</p>
                    <hr />

                    <h4>12. General</h4>
                    <p>12.1 The Organiser reserves the right to refuse entry or participation at their sole discretion.</p>
                    <p>12.2 These Terms & Conditions shall be governed by and interpreted in accordance with the laws of England and Wales.</p>
                    <p>12.3 Any disputes arising in connection with the Tournament shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>
                    <p>12.4 If any provision of these Terms & Conditions is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.</p>
                    <p>12.5 Entry into the Tournament constitutes full acceptance of these Terms & Conditions.</p>
                </div>
                <div className="terms-footer">
                    <button className="merky-btn" onClick={onAgreeClick}>
                        AGREE
                    </button>
                </div>
            </div>
        </CommonModal>
    );
}


export default TermsAgreementModal;